import type { ReactNode } from 'react'
import * as Mtds from '@mattilsynet/design/react'
import styles from './PillTag.module.css'

type PillTagProps = {
  children: ReactNode
  color?: 'neutral' | 'success'
  appearance?: 'subtle' | 'filled' | 'outlined'
  textColor?: 'default' | 'main'
  title?: string
  className?: string
  'aria-current'?: 'date'
}

export const PillTag = ({
  children,
  color,
  appearance = 'subtle',
  textColor = 'default',
  className,
  ...props
}: PillTagProps) => (
  <Mtds.Tag
    data-color={color}
    data-icon='none'
    className={`${styles.root} ${styles[appearance]} ${styles[textColor]} ${className ?? ''}`}
    {...props}
  >
    {children}
  </Mtds.Tag>
)
